import {LoaderStateModel} from '@store/loader/loader-state.model';
import {Action, State, StateContext} from '@ngxs/store';
import {Injectable} from '@angular/core';
import {
  ToggleDeviceLoader,
  ToggleGlobalLoader,
  ToggleGroupedDevicesLoader,
  ToggleGroupsLoader,
  ToggleMediaLoader,
  ToggleMetricsLoader,
  ToggleOfflineDevicesSummaryLoader,
  TogglePlaylistLoader,
  ToggleRssLoader,
  ToggleScheduledDevicesLoader,
  ToggleScheduledGroupsLoader,
  ToggleScheduleLoader, ToggleSettingsLoader,
  ToggleUnapprovedLoader,
  ToggleUngroupedDevicesLoader
} from '@store/loader/loader.actions';

@State<LoaderStateModel>({
  name: 'loaderState',
  defaults: {
    deviceLoader: false,
    ungroupedDevicesLoader: false,
    groupedDevicesLoader: false,
    unapprovedLoader: false,
    groupsLoader: false,
    scheduledGroupsLoader: false,
    scheduledDevicesLoader: false,
    rssLoader: false,
    mediaLoader: false,
    playlistLoader: false,
    scheduleLoader: false,
    metricsLoader: false,
    offlineDevicesSummaryLoader: false,
    globalLoader: false,
    settingsLoader: false,
  }
})
@Injectable()
export class LoaderState {
  constructor() {
  }

  @Action(ToggleDeviceLoader)
  toggleDeviceLoader(ctx: StateContext<LoaderStateModel>, {value}: ToggleDeviceLoader): void {
    ctx.patchState({deviceLoader: value});
  }

  @Action(ToggleUnapprovedLoader)
  toggleUnapprovedLoader(ctx: StateContext<LoaderStateModel>, {value}: ToggleUnapprovedLoader): void {
    ctx.patchState({unapprovedLoader: value});
  }

  @Action(ToggleGroupsLoader)
  toggleGroupsLoader(ctx: StateContext<LoaderStateModel>, {value}: ToggleGroupsLoader): void {
    ctx.patchState({groupsLoader: value});
  }

  @Action(ToggleMediaLoader)
  toggleMediaLoader(ctx: StateContext<LoaderStateModel>, {value}: ToggleMediaLoader): void {
    ctx.patchState({mediaLoader: value});
  }

  @Action(TogglePlaylistLoader)
  togglePlaylistLoader(ctx: StateContext<LoaderStateModel>, {value}: TogglePlaylistLoader): void {
    ctx.patchState({playlistLoader: value});
  }

  @Action(ToggleScheduleLoader)
  toggleScheduleLoader(ctx: StateContext<LoaderStateModel>, {value}: ToggleScheduleLoader): void {
    ctx.patchState({scheduleLoader: value});
  }

  @Action(ToggleGlobalLoader)
  toggleGlobalLoader(ctx: StateContext<LoaderStateModel>, {value}: ToggleGlobalLoader): void {
    ctx.patchState({globalLoader: value});
  }

  @Action(ToggleMetricsLoader)
  toggleMetricsLoader(ctx: StateContext<LoaderStateModel>, {value}: ToggleMetricsLoader): void {
    ctx.patchState({metricsLoader: value});
  }

  @Action(ToggleOfflineDevicesSummaryLoader)
  toggleOfflineDevicesSummaryLoader(
    ctx: StateContext<LoaderStateModel>,
    {value}: ToggleOfflineDevicesSummaryLoader
  ): void {
    ctx.patchState({offlineDevicesSummaryLoader: value});
  }

  @Action(ToggleUngroupedDevicesLoader)
  toggleUngroupedDevicesLoader(ctx: StateContext<LoaderStateModel>, {value}: ToggleUngroupedDevicesLoader): void {
    ctx.patchState({ungroupedDevicesLoader: value});
  }

  @Action(ToggleGroupedDevicesLoader)
  toggleGroupedDevicesLoader(ctx: StateContext<LoaderStateModel>, {value}: ToggleGroupedDevicesLoader): void {
    ctx.patchState({groupedDevicesLoader: value});
  }

  @Action(ToggleScheduledGroupsLoader)
  toggleScheduledGroupsLoader(ctx: StateContext<LoaderStateModel>, {value}: ToggleScheduledGroupsLoader): void {
    ctx.patchState({scheduledGroupsLoader: value});
  }

  @Action(ToggleScheduledDevicesLoader)
  toggleScheduledDevicesLoader(ctx: StateContext<LoaderStateModel>, {value}: ToggleScheduledDevicesLoader): void {
    ctx.patchState({scheduledDevicesLoader: value});
  }

  @Action(ToggleRssLoader)
  toggleRssLoader(ctx: StateContext<LoaderStateModel>, {value}: ToggleRssLoader): void {
    ctx.patchState({rssLoader: value});
  }

  @Action(ToggleSettingsLoader)
  toggleSettingsLoader(ctx: StateContext<LoaderStateModel>, {value}: ToggleSettingsLoader): void {
    ctx.patchState({settingsLoader: value});
  }
}
